<script setup lang="ts">
  import { computed } from 'vue';
  import Tabs from '@/shared/ui/navigation/Tabs.vue';

  const props = withDefaults(
    defineProps<{
      options: { text: string; icon?: string; id: string; badge?: string }[];
      selectedOption: string;
      visualVariant?: 'default' | 'neutral';
      mutedInactiveText?: boolean;
    }>(),
    {
      visualVariant: 'default',
      mutedInactiveText: false,
    }
  );

  const emit = defineEmits<{ 'option-selected': [optionId: string] }>();

  const handleOptionSelect = (optionId: string) => {
    emit('option-selected', optionId);
  };

  const shellVariantClass = computed(() => {
    if (props.visualVariant === 'neutral') {
      const inactiveTextClass = props.mutedInactiveText ? 'text-gray-03' : 'text-gray-07';
      return `rounded-xl p-1 gap-0.5 bg-[var(--color-gray-02)] ${inactiveTextClass}`;
    }
    return 'bg-[var(--theme-secondary-tint-subtle)] text-gray-03 rounded-lg divide-x divide-gray-02 p-0.5';
  });
</script>

<template>
  <div
    class="flex max-w-fit"
    :class="shellVariantClass"
  >
    <Tabs
      :options="props.options"
      :selected-option="props.selectedOption"
      :visual-variant="props.visualVariant"
      :muted-inactive-text="props.mutedInactiveText"
      @option-selected="handleOptionSelect"
    />
  </div>
</template>
